import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const areas = [
  {
    num: '01',
    icon: 'ri-heart-pulse-line',
    title: '의료장비 해외공급',
    titleEn: 'Medical Equipment Supply',
    color: '#0F7A5A',
    bg: '#F0FAF5',
    partner: 'Karl Group Holdings Corporation (Philippines)',
    partnerUrl: 'karlgroup.org',
    partnerDesc: 'Karl Group은 필리핀 잠보앙가에서 설립되어 민다나오, 마닐라, 비사야스, 루손 전역으로 사업을 확장한 필리핀 대표 의료 그룹입니다. 병원·클리닉 대상 의료장비 유통, 의료 시뮬레이션 교육, 병원 기술 관리, 의료 소프트웨어 개발 등 헬스케어 전반에 걸친 풍부한 포트폴리오를 보유하고 있습니다.',
    summary: 'Fixcope는 Karl Group의 공식 한국 파트너로서, 국내 우수 의료장비 및 관련 제품을 필리핀 시장에 안정적으로 공급합니다. 필리핀은 의료기기의 99% 이상을 수입에 의존하는 시장으로, 한국산 고품질 의료장비에 대한 수요가 높습니다.',
    items: [
      '병원용 진단 장비 (Hospital Diagnostic Equipment)',
      '의료용 영상 장비 — 초음파, 내시경 등',
      '의료 소모품 및 관련 제품',
      '의료 시뮬레이션 및 교육 장비',
    ],
    highlights: [
      { label: '시장 규모', value: '전국 1,915개+ 병원·의료시설' },
      { label: '수입 의존도', value: '의료기기 수입 비중 99% 이상' },
      { label: '성장성', value: '2028년까지 공공 의료시설 6,000개 확충' },
      { label: '파트너십', value: 'Karl Group 공식 한국 파트너' },
    ],
    image: 'https://public.readdy.ai/ai/img_res/5f6feff3cc3f1e77bee52fab2d68e530.jpg',
  },
  {
    num: '02',
    icon: 'ri-eye-line',
    title: '비전 인스펙션 솔루션',
    titleEn: 'Machine Vision Inspection',
    color: '#0F7A5A',
    bg: '#F0FAF5',
    partner: 'Inspiraz Technology Pte Ltd (Singapore)',
    partnerUrl: 'vizcam.net / inspiraz.com',
    partnerDesc: 'Inspiraz Technology는 2004년 싱가포르에 설립된 머신비전·자동화 전문 기업입니다. 20년 이상의 경험을 바탕으로 아시아 전역의 제조업 고객에게 비전 인스펙션, AI 딥러닝, 3D 비전, 열화상 관리 등 다양한 첨단 기술 솔루션을 제공하고 있습니다.',
    summary: 'Wizer는 Inspiraz가 개발한 머신비전 소프트웨어 플랫폼으로, 드래그 앤 드롭 방식의 직관적인 UI를 통해 프로그래밍 지식 없이도 다양한 비전 인스펙션 솔루션을 빠르게 구축할 수 있습니다.',
    items: [
      '코드 인식 및 추적 (Barcode / QR Code Reading)',
      '광학 문자 인식 — OCR',
      '치수 측정 및 정밀 검사',
      '표면 불량 검출 (Surface Defect Detection)',
      '로봇 가이던스 및 정렬',
      '색상 검사 (Color Inspection)',
    ],
    highlights: [
      { label: 'Wizer Pro', value: '고성능 범용 플랫폼' },
      { label: 'Wizer RTU', value: '20+ 사전 구성 모듈, 즉시 사용 가능' },
      { label: 'Wizer Intuit', value: 'AI 자가학습 — 소량 이미지로 불량 검출' },
      { label: 'Wizer 3D', value: '1시간 내 3D 인스펙션 솔루션 구축' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Industrial%20machine%20vision%20inspection%20system%20automated%20manufacturing%20quality%20control%20camera%20scanning%20production%20line%20precision%20technology%20green%20tones%20elegant%20dark%20background%20high%20tech%20industrial%20automation&width=800&height=500&seq=fixcope-vision-001&orientation=landscape',
  },
  {
    num: '03',
    icon: 'ri-camera-3-line',
    title: '초소형 헤드분리형 카메라',
    titleEn: 'Micro Detachable-Head Camera',
    color: '#0F7A5A',
    bg: '#F0FAF5',
    partner: 'Fixcope',
    partnerUrl: '',
    partnerDesc: 'Fixcope는 일반 카메라로는 접근이 불가능한 협소한 공간·특수 환경에서 사용 가능한 초소형 헤드분리형 카메라를 개발합니다.',
    summary: '카메라 헤드와 본체를 분리한 구조로 설계되어, 극소 공간에서도 고화질 영상 촬영이 가능합니다. Fixcope 독자 기술로 산업 현장의 특수 요구에 최적화되었습니다.',
    items: [
      '산업용 내시경 검사 — 배관, 엔진, 구조물 내부',
      '방산·항공우주',
      '연구 및 과학 분야',
      '건설·플랜트 설비 점검',
    ],
    highlights: [
      { label: '헤드분리형 구조', value: '초소형 사이즈 2.4X2.4mm' },
      { label: '고화질 이미징', value: '특수 환경에서도 선명한 영상 확보' },
      { label: '내구성', value: '산업·의료 현장 특수 환경 최적화' },
      { label: '원거리 영상전달', value: '최대 15M 영상전달' },
    ],
    image: 'https://static.readdy.ai/image/e26dc5fd8ad5af2fe8b73f60c590f9ca/345c1d41912f84687c667cc753c92727.png',
  },
  {
    num: '04',
    icon: 'ri-global-line',
    title: '글로벌 비즈니스 컨설팅',
    titleEn: 'Global Business Consulting',
    color: '#0F7A5A',
    bg: '#F0FAF5',
    partner: '아시아 · 아프리카 네트워크',
    partnerUrl: '',
    partnerDesc: 'Fixcope는 다양한 산업 분야에서 쌓은 글로벌 네트워크와 풍부한 프로젝트 경험을 바탕으로, 한국 기업의 해외 시장 진출을 위한 전문 컨설팅 서비스를 제공합니다.',
    summary: '단순한 정보 제공을 넘어, 파트너 발굴부터 계약 체결, 프로젝트 실행까지 전 과정을 함께합니다. 아시아&nbsp;·&nbsp;아프리카 진출을 목표로 하는 제조, 기술 기업들의 최적 파트너입니다.',
    items: [
      '해외시장 진출 전략 — 목표 시장 분석, 규제·인허가 가이드',
      '파트너 발굴 및 협상 — 현지 신뢰 파트너 매칭, MOU 지원',
      '프로젝트 관리 — 기획부터 납품·사후관리까지',
      '글로벌 네트워크 연결 — 아시아·아프리카 활용',
    ],
    highlights: [
      { label: '의료기기 기업', value: '필리핀·동남아시아 시장 진출 지원' },
      { label: '제조기업', value: '해외 산업 자동화·비전 인스펙션 프로젝트' },
      { label: '스타트업', value: '글로벌 파트너십 구축 지원' },
      { label: '중견기업', value: '검증된 현지 네트워크 즉시 활용' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Global%20business%20consulting%20world%20map%20connections%20Southeast%20Asia%20Philippines%20Singapore%20network%20professional%20meeting%20room%20executive%20elegant%20dark%20atmosphere%20with%20glowing%20connection%20lines%20representing%20international%20partnerships%20green%20accents%20modern%20corporate%20setting&width=800&height=500&seq=fixcope-consulting-001&orientation=landscape',
  },
];

export default function BusinessAreas() {
  const [active, setActive] = useState(0);
  const headerAnim = useScrollAnimation();
  const contentAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  const area = areas[active];

  return (
    <section id="business" className="py-16 sm:py-20 md:py-28 bg-[#FFFBF5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headerAnim.ref}
          className={`text-center mb-16 transition-all duration-700 ${headerAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
            <span className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest whitespace-nowrap">Business Areas</span>
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A2530] mb-4">4대 핵심 사업 부문</h2>
          <p className="text-gray-500 text-[15px] max-w-xl mx-auto">
            기술과 글로벌 네트워크를 융합한 Fixcope의 전문 사업 영역
          </p>
        </div>

        {/* Tab Buttons */}
        <div className="flex overflow-x-auto sm:flex-wrap sm:justify-center gap-3 mb-10 sm:mb-12 pb-1 sm:pb-0 -mx-2 px-2 sm:mx-0 sm:px-0 scrollbar-hide">
          {areas.map((a, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`flex flex-col sm:flex-row items-center sm:gap-2 px-3 sm:px-5 py-2.5 sm:py-3 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer shrink-0 text-center sm:text-left ${
                active === i
                  ? 'bg-[#E8650A] text-white shadow-sm'
                  : 'bg-white text-gray-500 border border-gray-200 hover:border-[#E8650A] hover:text-[#E8650A]'
              }`}
            >
              <span className="text-[10px] sm:text-xs font-bold opacity-60">{a.num}</span>
              <span className="break-keep">{a.title}</span>
            </button>
          ))}
        </div>

        {/* Content */}
        <div
          ref={contentAnim.ref}
          key={active}
          className={`transition-all duration-500 ${contentAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left: Image + Partner */}
            <div className="space-y-5">
              <div className="rounded-2xl overflow-hidden h-64 md:h-72">
                <img
                  src={area.image}
                  alt={area.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Partner Card */}
              <div className="bg-white rounded-2xl p-6 border border-gray-100">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#E8650A]/10 shrink-0">
                    <i className="ri-building-2-line text-lg text-[#E8650A]"></i>
                  </div>
                  <div>
                    <div className="text-xs text-[#E8650A] font-semibold mb-1 uppercase tracking-wide whitespace-nowrap">Partner</div>
                    <h4 className="text-sm font-bold text-[#1A2530] mb-1">{area.partner}</h4>
                    {area.partnerUrl && (
                      <p className="text-xs text-gray-400 mb-2">{area.partnerUrl}</p>
                    )}
                    <p className="text-xs text-gray-500 leading-relaxed">{area.partnerDesc}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Details */}
            <div className="space-y-5">
              {/* Title */}
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#E8650A]/10">
                    <i className={`${area.icon} text-xl text-[#E8650A]`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2530]">{area.title}</h3>
                    <p className="text-xs text-gray-400">{area.titleEn}</p>
                  </div>
                </div>
                <p className="text-[14px] text-gray-600 leading-relaxed">{area.summary}</p>
              </div>

              {/* Apply Areas */}
              <div className="bg-white rounded-2xl p-5 border border-gray-100">
                <h5 className="text-xs font-bold text-[#1A2530] uppercase tracking-wider mb-4 whitespace-nowrap">주요 분야</h5>
                <ul className="space-y-2">
                  {area.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-[13px] text-gray-600">
                      <i className="ri-checkbox-circle-line text-[#E8650A] text-base shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Highlights Grid */}
              <div className="grid grid-cols-2 gap-3">
                {area.highlights.map((h, i) => (
                  <div key={i} className="bg-[#FEF3E8] rounded-xl p-4 border border-[#FDDDB4]">
                    <div className="text-[10px] text-[#E8650A] font-bold uppercase tracking-wide mb-1 break-keep">{h.label}</div>
                    <div className="text-xs text-[#1A2530] font-medium leading-snug">{h.value}</div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <button
                onClick={() => {
                  const el = document.querySelector('#contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-2 text-sm font-semibold text-[#E8650A] hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
              >
                이 분야 문의하기 <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
